<template>
  <MainLayout>
    <AppBreadcrumb
      title="404 Not Found"
      :items="[
        { text: 'ပင်မစာမျက်နှာ', to: { name: 'homeIndex' } },
        { text: 'ရှာမတွေ့ပါ' }
      ]"
    />
    <section class="sec-wrap sec-error-wrap">
      <div class="cmn-card-no-border error-card">
        <div class="icon-frame">
          <app-icon name="compass" size="48" class="not-found-icon" aria-hidden="true" />
          <span class="badge badge-404 en">404</span>
        </div>
        <div class="content-group">
          <h2 class="title">ရှာမတွေ့ပါ</h2>
          <p class="description">
            တောင်းပန်ပါတယ်။ သင်ရှာဖွေနေသော စာမျက်နှာသည် ရွှေ့ပြောင်းသွားခြင်း သို့မဟုတ် ဖျက်လိုက်ခြင်းကြောင့် မရှိတော့ပါ သို့မဟုတ် လိပ်စာမှားယွင်းနေပါသည်။
          </p>
        </div>
        <div class="btn-container">
          <router-link :to="homeRoute" class="btn btn-back">
            ပင်မစာမျက်နှာ
          </router-link>
        </div>
        <div class="contact-us-container">
          မေးမြန်းလိုသည်များရှိပါက <router-link :to="{ name: 'contactUsNew' }" class="green-txt">ဆက်သွယ်ရန်</router-link>ကို နှိပ်ပြီး မေးမြန်းနိုင်ပါသည်။
        </div>
      </div>
    </section>
  </MainLayout>
</template>

<script>
import MainLayout from "@/components/layout/applicant/MainLayout.vue";
export default {
  name: "notFound",
  components: {
    MainLayout
  },
  data() {
    return {
      homeRoute: { name: 'homeIndex' }
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.path.startsWith('/company')) {
        vm.homeRoute = { name: 'companyIndex' };
      } else if (to.path.startsWith('/admin')) {
        vm.homeRoute = { name: 'adminIndex' };
      } else if (from && from.path) {
        if (from.path.startsWith('/company')) {
          vm.homeRoute = { name: 'companyIndex' };
        } else if (from.path.startsWith('/admin')) {
          vm.homeRoute = { name: 'adminIndex' };
        }
      }
    });
  }
};
</script>